import { feesHardcode } from "./additionalFees";

export class MonthlyFees {
	isPinDebitEnabled = false;
	pinDebitSponsorship = false;
	amexType = "OptBlue";
	tinInvalidFee = feesHardcode.tinInvalidFee;
	achRejectFee = feesHardcode.achRejectFee;
	merchantMonitoringFee = feesHardcode.merchantMonitoringFee;
	chargebackFee = feesHardcode.chargebackFee;
	toBeBilled = "0";
	monthPCIAnnualFeeCharged = "12";
	isActiveAmexOptBlueOrEsaSection = false;
}
